import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { contactData } from '../../data/mock';

const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    // Show button after scrolling a bit
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    
    // Show tooltip after 5 seconds
    const tooltipTimer = setTimeout(() => {
      setShowTooltip(true);
    }, 5000);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(tooltipTimer);
    };
  }, []);

  return (
    <div className={`fixed bottom-6 right-6 z-50 transition-all duration-500 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'}`}>
      {/* Tooltip */}
      {showTooltip && (
        <div className="absolute bottom-full right-0 mb-3 animate-bounce">
          <div className="relative bg-white rounded-xl shadow-lg border border-slate-200 p-4 max-w-[240px]">
            <button 
              onClick={() => setShowTooltip(false)}
              className="absolute -top-2 -right-2 w-6 h-6 bg-slate-100 rounded-full flex items-center justify-center hover:bg-slate-200 transition-colors"
            >
              <X className="w-3 h-3 text-slate-600" />
            </button>
            <p className="text-sm text-slate-700 font-medium">
              Tire suas dúvidas agora pelo WhatsApp!
            </p>
            <div className="absolute bottom-0 right-6 translate-y-full">
              <div className="w-3 h-3 bg-white border-r border-b border-slate-200 transform rotate-45 -translate-y-1.5" />
            </div>
          </div>
        </div>
      )}

      {/* WhatsApp Button */}
      <a
        href={contactData.whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className="group flex items-center gap-3 bg-emerald-500 hover:bg-emerald-600 text-white rounded-full shadow-lg shadow-emerald-500/30 hover:shadow-xl hover:shadow-emerald-500/40 transition-all duration-300"
      >
        <div className="flex items-center justify-center w-14 h-14 relative">
          <MessageCircle className="w-7 h-7" />
          {/* Pulse animation */}
          <span className="absolute inset-0 rounded-full bg-emerald-400 animate-ping opacity-30" />
        </div>
        <span className="pr-5 font-semibold hidden sm:block group-hover:block transition-all duration-300">
          Falar no WhatsApp
        </span>
      </a>
    </div>
  );
};

export default WhatsAppButton;
